import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
export var ArrowLeftIcon = function ArrowLeftIcon(props) {
  return React.createElement(SvgIcon, props, React.createElement("path", {
    d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
  }), React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }));
};